import { partyLines } from '@/lib/lab/labDisplay';
import type { LabParty, LabPartyRegister } from '@/lib/lab/labTypes';

function registerLabel(register: LabPartyRegister): string {
  switch (register.status) {
    case 'paired':
      return 'Parret';
    case 'created':
      return 'Oprettet';
    default: {
      const _never: never = register.status;
      return _never;
    }
  }
}

export function LabPartyBlock({
  title,
  party,
  register,
}: {
  title: string;
  party: LabParty | null | undefined;
  register?: LabPartyRegister | null;
}) {
  const lines = partyLines(party);
  return (
    <div className="lab-field">
      <dt>{title}</dt>
      <dd>
        {lines.length === 0
          ? '—'
          : lines.map((line) => (
              <div key={line}>{line}</div>
            ))}
        {register ? (
          <div className="mt-s2 text-sm text-ds-muted">
            <span className={register.status === 'paired' ? 'lab-chip lab-chip--copy' : 'lab-chip'}>
              {registerLabel(register)}
            </span>{' '}
            {register.detail}
          </div>
        ) : null}
      </dd>
    </div>
  );
}
